export default {
    namespaced: 'true',
    state: getDefaultState(),
    mutations: {
        setVisible(state, value) {
            if (!value) {
                state.headerDatum = {};
                state.secondPanelVisibility = false;
            }

            state.visible = value;
        },
        setHeaderDatum(state, headerDatum) {
            state.headerDatum = headerDatum;
        },
        setSecondPanelVisibility(state, value) {
            state.secondPanelVisibility = value;
        },
        setEditableHeaderList(state, list) {
            state.headerDatum = R.assoc(
                'editableHeaderList',
                list,
                state.headerDatum
            );
        },
        setWidgetRefresh(state, value) {
            state.widgetRefresh$ = value;
        },
        resetWidgetData(state) {
            state.widgetRefresh$ = undefined;
            state.headerDatum = {};
        },
        setGridShowTotalRow(state, value) {
            state.gridShowTotalRow = value;
        },
    },
    actions: {},
    getters: {
        editableHeaderList: R.pathOr([], ['headerDatum', 'editableHeaderList']),
        updateEditableHeaderList: R.pathOr(R.identity, [
            'headerDatum',
            'updateEditableHeaderList',
        ]),
    },
};

function getDefaultState() {
    return {
        visible: false,
        secondPanelVisibility: false,
        headerDatum: {},
        widgetRefresh$: undefined,
        gridShowTotalRow: true,
    };
}
